module.exports = __webpack_public_path__ + "static/media/rem-galleu-icon.2ba6d5ab.png";